  <template>
    <div class="full ">
      <Pipeline ref="pipeline" style="width: 100%; height: 100%;" v-if="toucher" :toucher="toucher" :useBloom="true" :bloomPass="bloomPass">
        <template slot-scope="temp" slot="scene">
          <Particles :amount="200" v-if="temp" :engine="temp"></Particles>

          <!-- <LoadingGL :visible="true" @add-exec="(fn) => { temp.execStack.push(fn) }" :scene="temp.scene" :exec="temp.execStack" :renderer="temp.renderer"></LoadingGL> -->
        </template>
      </Pipeline>


      <div class="overlay" ref="toucher"></div>
        <div class="admin overlay lobby">
          <div class="lobby-wrapper">
            <h1>
              PALMS ONLY Admin Page
            </h1>
            <h3>
              Question Bank for Cell-Game
            </h3>
          <h2 >
            <span
              @click="$router.push('/')" style="text-decoration: underline;"
              class="action"
              >
            Go Back Home

            </span>
          </h2>
          <div>

            <!-- <div v-if="false">
              <h2>My Games</h2>
              <div>
                Room Size:
                <select v-model="config">
                  <option :key="item.sizeX + '-' + item.sizeY" :value="item" v-for="item in items">Tiles: {{ item.sizeX }}x{{ item.sizeY }}, Best for: {{ item.bestFor }}</option>
                </select>
                <div>
                  <span class="action" @click="createUserRoom(config)">Create My Room</span>
                </div>
              </div>
              <div class="lobby-list">
                <div class="room-list">
                  <div class="room-item" :key="room.roomID" v-for="(room) in mygames">
                    <div>
                      <div>
                        <span>
                          <textarea :placeholder="`question bank folderID`" v-model="room.title" @input="updateUserGameField(room, 'title')" ></textarea>
                        </span>

                        <span class="action" @click="enterRoom(room)">Enter: {{ room.title }} ({{ room.sizeX }}x{{ room.sizeY }})</span>
                        <span class="action" @click="deleteUserRoomConfirm(room)">
                          Delete Room
                        </span>
                      </div>
                    </div>
                    <div class="flex-row">
                      <GameAutoBtns :room="room"></GameAutoBtns>
                    </div>
                    <div>
                      <router-link class="action" style="color: white;" :to="`/analytics/${room.roomID}/${room.title}`">Analytics</router-link>

                      <label style="margin-left: 10px;" :for="room.roomID + '_pw'">
                        <input type="checkbox" :id="room.roomID + '_pw'" v-model="room.enableEntryPassword" @change="updateUserGameField(room, 'enableEntryPassword')" />
                        Enbale Password
                      </label>
                      <input type="password" v-model="room.entryPassword" @input="updateUserGameField(room, 'entryPassword', 'encrypt')">
                    </div>

                    <div class="flex-row" v-if="false">
                      <div>
                        <p>Easy</p>
                        <vue-simple-suggest
                          style="color: black; width: 250px;"
                          v-model="room.easyQuestion"
                          :list="getQuestionTag()"
                          :filter-by-query="true"
                          @input="updateUserGameField(room, 'easyQuestion')"
                          >
                        </vue-simple-suggest>
                      </div>
                      <div>
                        <p>Medium</p>
                        <vue-simple-suggest
                          style="color: black; width: 250px;"
                          v-model="room.mediumQuestion"
                          :list="getQuestionTag()"
                          :filter-by-query="true"
                          @input="updateUserGameField(room, 'mediumQuestion')"
                          >
                        </vue-simple-suggest>
                      </div>
                      <div>
                        <p>Difficult</p>
                        <vue-simple-suggest
                          style="color: black; width: 250px;"
                          v-model="room.hardQuestion"
                          :list="getQuestionTag()"
                          :filter-by-query="true"
                          @input="updateUserGameField(room, 'hardQuestion')"
                          >
                        </vue-simple-suggest>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="border-top" v-if="isOneOfAdmin">
              <h2>PALMS Team Admin Area </h2>
              <h3>
                (This is only visible to PALMS Team.)
              </h3>
              <span class="action" @click="createRoom(config)">Create New Game</span>
              <select v-model="config">
                <option :key="item.sizeX + '-' + item.sizeY" :value="item" v-for="item in items">Tiles: {{ item.sizeX }}x{{ item.sizeY }} (Best for: {{ item.bestFor }})</option>
              </select>
              <div class="room-list">
                  <div class="room-item" :key="room.roomID" v-for="(room, ii) in rooms">
                  <input type="text" :placeholder="`Room ${ii}`" class="newtext" v-model="room.title" @input="updateTitle(room)" />
                  <router-link tag="span" class="action" :to="`/game-play/${room.roomID}`">Go to Room</router-link>
                  <!--  -->
                  <!-- <span class="action" @click="resetRoom(room)">Reset Room</span> -->
                  <span class="action" v-if="!room.trashed" @click="trashRoom(room)">Trash</span>
                  <span class="action" v-if="room.trashed" @click="restoreRoom(room)">Restore Room</span>
                  <span class="action" v-if="room.trashed" @click="deleteRoom(room)">Delete Room</span>


                  <!-- omg -->
                  <div class="flex-row">
                    <div class="">
                      <p>
                        Stat
                      </p>
                      <div>
                        <router-link class="action" style="color: white;" :to="`/analytics/${room.roomID}/${room.title}`">Analytics</router-link>
                      </div>
                    </div>
                    <div>
                      <p>Pinned</p>
                      <div>
                        <input type="checkbox" v-model="room.pinned"
                        @change="updateField(room, 'pinned')"
                        >
                      </div>
                    </div>
                    <div>
                      <p>Frozen</p>
                      <div>
                        <input type="checkbox" v-model="room.frozen"
                        @change="updateField(room, 'frozen')"
                        >
                      </div>
                    </div>
                    <div>
                      <p>Size</p>
                      <div>
                        {{ room.sizeX + 'x' + room.sizeY }}
                      </div>
                    </div>

                    <div class="">
                        <div>
                            <p>Easy</p>
                            <vue-simple-suggest
                              style="color: black; width: 250px;"
                              v-model="room.easyQuestion"
                              :list="getQuestionTag()"
                              :filter-by-query="true"
                              @input="updateField(room, 'easyQuestion')"
                              >
                            </vue-simple-suggest>
                            <!-- <textarea :placeholder="`question bank folderID`" class="newtext" v-model="room.easyQuestion" @input="updateField(room, 'easyQuestion')" ></textarea> -->
                          </div>
                          <div>
                            <p>Medium</p>
                            <vue-simple-suggest
                              style="color: black; width: 250px;"
                              v-model="room.mediumQuestion"
                              :list="getQuestionTag()"
                              :filter-by-query="true"
                              @input="updateField(room, 'mediumQuestion')"
                              >
                            </vue-simple-suggest>
                            <!-- <textarea :placeholder="`question bank folderID`" class="newtext" v-model="room.mediumQuestion" @input="updateField(room, 'mediumQuestion')" ></textarea> -->
                          </div>
                          <div>
                            <p>Difficult</p>
                            <vue-simple-suggest
                              style="color: black; width: 250px;"
                              v-model="room.hardQuestion"
                              :list="getQuestionTag()"
                              :filter-by-query="true"
                              @input="updateField(room, 'hardQuestion')"
                              >
                            </vue-simple-suggest>
                            <!-- <textarea :placeholder="`question bank folderID`" class="newtext" v-model="room.hardQuestion" @input="updateField(room, 'hardQuestion')" ></textarea> -->
                          </div>
                      </div>
                  </div>



                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </template>

<script>
import { State } from '../game/auth.js'
import { FDB, toArr } from '../game/firebase.js'
import VueSimpleSuggest from 'vue-simple-suggest'
import * as Folders from '@/api/folders.js'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS
var compress = require('compress-str')
export default {
  components: {
    VueSimpleSuggest,
    GameAutoBtns: require('../game-ui/GameAutoBtns.vue').default,
    Pipeline: require('../game/Pipeline.vue').default,
    Particles: require('../game/Particles.vue').default
  },
  data () {
    return {
      rooms: [],
      mygames: [],
      toucher: false,
      useBloom: true,
      bloomPass: {

        threshold: 1,
      },
      isOneOfAdmin: false,
      config: {
        sizeX: 75,
        sizeY: 75,
        bestFor: '70-100 people'
      },
      items:[
        { sizeX: 10, sizeY: 10, bestFor: '1-10 people (quickplay)' },
        { sizeX: 15, sizeY: 15, bestFor: '10-15 people (quickplay)' },
        { sizeX: 20, sizeY: 20, bestFor: '15-20 people (quickplay)' },
        { sizeX: 25, sizeY: 25, bestFor: '1-30 people' },
        { sizeX: 50, sizeY: 50, bestFor: '30-70 people' },
        { sizeX: 75, sizeY: 75, bestFor: '70-100 people' },
        { sizeX: 100, sizeY: 100, bestFor: '100-150 people' }//,
        // { sizeX: 200, sizeY: 200, bestFor: '150-200' }
      ]
    }
  },
  mounted () {
    this.toucher = this.$refs.toucher
    this.listAdmins()
    this.getMyGames()
    this.listAdminRooms()
  },
  methods: {
    getQuestionTag () {
      return async (query) => {
        console.log(query)
        let tags = []
        let resp = await Folders.queryFolder({ query })
        let data = resp.data
        if (data) {
          tags = data.reduce((arr, item) => {
            item.tags = item.tags || []
            arr.push(...item.tags)
            return arr
          }, [])
          if (tags) {
            return tags
          }
        }
      }
    },
    getMyGames () {
      this.mygames = []
      let waitUntil = (cb) => {
        let tt = setInterval(() => {
          if (State.user.uid) {
            clearInterval(tt)
            cb()
          }
        }, 0)
      }
      waitUntil(() => {
        FDB.ref(`/user-games`).orderByChild('userID').equalTo(State.user.uid).on('value', (snap) => {
          let value = snap.val()
          this.mygames = value
        })
      })
    },
    listAdmins () {
      FDB.ref(`/admins`).on('value', (snap) => {
        this.admins = toArr(snap.val()).map(e => e._id)
        this.isOneOfAdmin = this.admins.includes(State.user.uid)
      })
    },
    listAdminRooms () {
      FDB.ref(`/admin-games`).on('value', (snap) => {
        this.rooms = toArr(snap.val())

        if (this.$route.query.retry) {
          this.$emit('room', this.rooms.find(e => e._id === this.$route.query.retry))
        }

        // setTimeout(() => {
        //
        // }, 1000)
        // debug
        // this.$emit('room', this.rooms[this.rooms.length - 1])
      })
    },
    createRoom ({ sizeX = 200, sizeY = 200 }) {
      let newItemKey = FDB.ref(`/admin-games`).push().key
      FDB.ref(`/admin-games/${newItemKey}`).set({
        type: 'admin-games',
        trashed: false,
        roomID: newItemKey,
        title: 'new room',
        roomNum: this.rooms.length + 1,
        sizeX,
        sizeY
      })
    },
    createUserRoom ({ sizeX = 200, sizeY = 200 }) {
      let newItemKey = FDB.ref(`/user-games`).push({
        userID: State.user.uid,
      }).key

      FDB.ref(`/user-games/${newItemKey}`).set({
        type: 'user-games',
        userID: State.user.uid,
        trashed: false,
        roomID: newItemKey,
        title: 'new room',
        roomNum: this.rooms.length + 1,
        sizeX,
        sizeY
      })
    },
    updateUserGameField (room, field, mode) {
      FDB.ref(`/user-games/${room.roomID}/${field}`).set(room[field])
    },
    updateField(room, field) {
      FDB.ref(`/admin-games/${room.roomID}/${field}`).set(room[field])
    },
    updateTitle (room) {
      FDB.ref(`/admin-games/${room.roomID}/title`).set(room.title)
    },
    deleteUserRoomConfirm (room) {
      if (window.prompt(`please copy and paste to confirm detele. "${room.title}"`)) {
        FDB.ref(`/user-games/${room.roomID}`).remove()
        FDB.ref(`/players/${room.roomID}`).remove()
      }
    },
    deleteRoom (room) {
      if (window.confirm('remove\n' + room.title + ' ?')) {
        FDB.ref(`/admin-games/${room.roomID}`).remove()
        FDB.ref(`/players/${room.roomID}`).remove()
      }
    },
    trashRoom (room) {
      FDB.ref(`/admin-games/${room.roomID}/trashed`).set(true)
    },
    restoreRoom (room) {
      FDB.ref(`/admin-games/${room.roomID}/trashed`).set(false)
    },
    enterRoom (room) {
      window.location.assign(`/game?retry=${room.roomID}`)
    }
  }
}
</script>

<style scoped>
.suggestions{
  color: black;
}
.lobby{
  font-size: 20px;
  color: white;

  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.lobby-wrapper{
  margin: 30px;
}
.lobby-title{
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 30px;
}

.overlay{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: red; */
}
.admin{
  color: white;
}

.action{
  font-size: 20px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  text-decoration: underline
}

.room-item{
  border: white solid 3px;
  margin: 20px;
  padding: 10px;
}
.room-list .action{
  margin-left: 10px;
}

.newtext{
  font-size: 20px;
  background-color: transparent;
  color: white;
  border: none;
  border-bottom: white solid 3px;
  height: 70px;
}

.flex-row{
  display: flex;
  /* justify-content: space-around; */
}
.flex-row > div{
  margin: 10px;
}

.tab-button{
  border: white solid 1px;
  padding: 10px 20px;
  margin: 10px;
  font-size: 30px;
  display: inline-block;
  cursor: pointer;
}

.border-top{
  margin-top: 50px;
  border-top: white solid 3px;
}
</style>
